export const dynamicHeadline: string[] = [
  'Powerful Title Ideas to Elevate Your Blog and Captivate Your Readers 💡📝✨',
  'Get Inspired with Eye-Catching Article and Blog Post Title Ideas! 💡✍️',
  'Captivating Titles for Your Next Blog Post or Article 💻🔥',
]
